import React, { useState, useEffect } from "react";
import { Link } from "gatsby"

import Layout from "../components/layout"
// import Image from "../components/image"
import SEO from "../components/seo"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby";
import moment from "moment";



const IndexPage = () => {
  const [years, setYears] = useState(0);
  const [months, setMonths] = useState(0);
  const [days, setDays] = useState(0);
  const [engagedYears, setEngagedYears] = useState(0);
  const [engagedMonths, setEngagedMonths] = useState(0);
  const [engagedDays, setEngagedDays] = useState(0);


  useEffect(() => {
    // Calculate years in love
    const startDate = moment([2012, 4, 11]);
    let now = moment();
    let numSeconds = now.diff(startDate, "seconds", true);
    let numYears = numSeconds / 31556952;
    let numMonths = (numYears * 12) % 12;
    let numDays = (numMonths * 30) % 30;
    setYears(Math.floor(numYears));
    setMonths(Math.floor(numMonths));
    setDays(Math.floor(numDays));

    // Calculate years engaged
    const engagedStartDate = moment([2020, 9, 8]);
    now = moment();
    numSeconds = now.diff(engagedStartDate, "seconds", true);
    numYears = numSeconds / 31556952;
    numMonths = (numYears * 12) % 12;
    numDays = (numMonths * 30) % 30;
    setEngagedYears(Math.floor(numYears));
    setEngagedMonths(Math.floor(numMonths));
    setEngagedDays(Math.floor(numDays));
  });


  const coupleData = useStaticQuery(graphql`
    query {
      allFile (
        filter: {
          relativeDirectory: { eq: "dating" }
        }
      ) {
        edges {
          node {
            name
            childImageSharp {
              fluid(maxHeight: 1000) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  `)

  const images = coupleData.allFile.edges.sort((a, b) => {
    if (a.node.name > b.node.name) {
      return 1;
    } else if (a.node.name < b.node.name) {
      return -1;
    } else {
      return 0;
    }
  });
  
  const imgComponents = images.map((edge) => {
    const node = edge.node;
    return (
      <div className="imgContainer">
        <Img className="img" fluid={node.childImageSharp.fluid} />
      </div>
    );
  });

  return (
    <Layout>
      <SEO title="Jen ❤️ Zain" />
      <div className="paragraphContainer">
        We've been in ❤️  &nbsp;for {years} years, {months} months, and {days} days now...
      </div>
      <div className="paragraphContainer">
        We've been engaged for {engagedYears} years, {engagedMonths} months, and {engagedDays} days now! 🎉 &nbsp;❤️
        <br />
        <span className="sideNote">
          <Link to="/proposal">Click here to view photos of when I proposed to Jen 🥰</Link>
        </span>
      </div>
      <div className="paragraphContainer">
        Look at all the fun and good times we've had...
        <br/>
        <span className="sideNote">
          (Scroll all the way to the bottom)
        </span>
      </div>
      <div className="flexContainer">
        {imgComponents}
      </div>
      <div className="paragraphContainer">
        <Link to="/proposal">I've asked you something...</Link>
      </div>
    </Layout>
  );
}

export default IndexPage
